import { defineStore } from 'pinia';
import axios from 'axios';
import { nestedAssign } from '@services/Helpers';

const apiClient = axios.create({
    baseURL: '/',
    withCredentials: true, // required to handle the CSRF token
});

// eslint-disable-next-line import/prefer-default-export
export const useLayoutHandlerStore = defineStore('layout-handler', {
    state: () => ({
        app: {},
        config: {},
        sidebar: {
            menu: {
                items: [],
                active_tag: '',
                loading: false,
                error: null,
            },
            color: null,
        },
        topbar: {
            logo: null,
            color: null,
        },
        override: {
            topbar_color: null,
            sidebar_color: null,
        },
    }),
    actions: {
        async initLayout() {
            this.setSidebar(window.config?.layouthandler?.sidebar);
            this.setTopbar(window.config?.layouthandler?.topbar);
            this.setConfig(window.config?.layouthandler);
            this.setApp(window.config?.app);
            if (window.config?.layouthandler?.sidebar?.menu?.active_tag) {
                this.setActiveTag(window.config.layouthandler.sidebar.menu.active_tag);
            }
            this.getSidebarMenuItems();
        },
        setSidebar(data) {
            this.sidebar = nestedAssign(this.sidebar, data);
        },
        setTopbar(data) {
            this.topbar = nestedAssign(this.topbar, data);
        },
        setConfig(data) {
            delete data.sidebar;
            delete data.topbar;
            this.config = nestedAssign(this.config, data);
        },
        setOverride(data) {
            this.override = nestedAssign(this.override, data);
        },
        setApp(data) {
            this.app = nestedAssign(this.app, data);
        },
        setActiveTag(data) {
            this.sidebar.menu.active_tag = data;
        },
        getSidebarMenuItems() {
            this.sidebar.menu.loading = true;
            apiClient.get('/api/layouthandler/sidebar/menu').then((response) => {
                this.sidebar.menu.items = response.data;
            }).catch(() => {
                this.sidebar.menu.items = [];
            }).finally(() => {
                this.sidebar.menu.loading = false;
            });
        },
    },
});
